"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vobarno": {
    "7712b3e7": [{
      "hkey": "ef5b6c3a",
      "slug": "cecino-degagna-san-martino",
      "name": "Cecino-Degagna-San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "cecino": [{
      "hkey": "ef5b6c3a",
      "slug": "cecino-degagna-san-martino",
      "name": "Cecino-Degagna-San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vobarno"
    }],
    "2864e9f4": [{
      "hkey": "ef5b6c3a",
      "slug": "cecino-degagna-san-martino",
      "name": "Cecino-Degagna-San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "degagna-busignone": [{
      "hkey": "ef5b6c3a",
      "slug": "cecino-degagna-san-martino",
      "name": "Cecino-Degagna-San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4e06e5d6": [{
      "hkey": "e657bdb6",
      "slug": "vobarno",
      "name": "Vobarno",
      "primary": true,
      "skipSearch": false
    }],
    "fustegnago": [{
      "hkey": "e657bdb6",
      "slug": "vobarno",
      "name": "Vobarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5659829": [{
      "hkey": "e657bdb6",
      "slug": "vobarno",
      "name": "Vobarno",
      "primary": true,
      "skipSearch": false
    }],
    "lizzane": [{
      "hkey": "e657bdb6",
      "slug": "vobarno",
      "name": "Vobarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5e3c19ce": [{
      "hkey": "e657bdb6",
      "slug": "vobarno",
      "name": "Vobarno",
      "primary": true,
      "skipSearch": false
    }],
    "pompegnino": [{
      "hkey": "e657bdb6",
      "slug": "vobarno",
      "name": "Vobarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "63898735": [{
      "hkey": "ef5b6c3a",
      "slug": "cecino-degagna-san-martino",
      "name": "Cecino-Degagna-San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "ef5b6c3a",
      "slug": "cecino-degagna-san-martino",
      "name": "Cecino-Degagna-San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vobarno"
    }],
    "626b20c6": [{
      "hkey": "7620a907",
      "slug": "teglie",
      "name": "Teglie",
      "primary": true,
      "skipSearch": false
    }],
    "teglie-casale": [{
      "hkey": "7620a907",
      "slug": "teglie",
      "name": "Teglie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d6972480": [{
      "hkey": "e657bdb6",
      "slug": "vobarno",
      "name": "Vobarno",
      "primary": true,
      "skipSearch": false
    }],
    "tiole-tegliole": [{
      "hkey": "e657bdb6",
      "slug": "vobarno",
      "name": "Vobarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;